<image-cropper
  (cropperReady)="ready()"
  (imageCropped)="imageCropped($event)"
  [aspectRatio]="1"
  [imageURL]="avatar | publicImageUrl:1000:1000:'zalamo':true | async"
  [maintainAspectRatio]="true"
  [onlyScaleDown]="true"
  [roundCropper]="true"
  format="jpeg"
  output="base64"

></image-cropper>
<div>

  <lib-button (click)="save()" lg>Zapisz</lib-button>

</div>
